import { ProviderKey } from '@kurtosys/types/portal/index.js';
import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptionsExternalApi } from '@kurtosys/types/query/options/externalApi/IQueryOptionsExternalApi.js';

import { BaseQuery } from '../queries/base/BaseQuery.js';

import { DxmProvider } from './provider/dxm/DxmProvider.js';
import { MpiProvider } from './provider/mpi/MpiProvider.js';
import { ProviderBase } from './provider/ProviderBase.js';
export class ExternalApiQuery extends BaseQuery<IQueryOptionsExternalApi> {
	get providers(): {
		[ProviderKey.MPI]: typeof MpiProvider;
		[ProviderKey.DXM]: typeof DxmProvider;
	} {
		return {
			[ProviderKey.MPI]: MpiProvider,
			[ProviderKey.DXM]: DxmProvider,
		};
	}
	initialize(executionOptions: IExecutionOptions): void {
		this.fillKeyFromQuery('id', 'idQuery', executionOptions);
	}
	getOptions(): IQueryOptionsExternalApi {
		const { options = {} } = this.queryOptions;
		return options.externalApi || {};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions, callStackLevel = 1): T {
		const externalApiRequest = this.getExternalApiRequest(this.options, executionOptions);
		if (externalApiRequest) {
			let query: BaseQuery | undefined;
			const { providerKey } = externalApiRequest;
			// eslint-disable-next-line @typescript-eslint/naming-convention
			const ProviderClass = this.providers[providerKey];
			let provider: ProviderBase | undefined;
			if (ProviderClass) {
				provider = new ProviderClass(externalApiRequest);
			}
			if (provider) {
				query = provider.getQuery(this.dependencies, this.queryOptions, this.translationHelper);
			}
			if (query) {
				return query.execute(executionOptions, callStackLevel + 1);
			}
		}
		return;
	}
}
